module.exports = __webpack_public_path__ + "static/about-team2-c2523b43f8744ae678d8f92e70865fc7.jpg";